import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import LandingPage from './pages/LandingPage/LandingPage';
import MoreAbout from './pages/MoreAbout/MoreAbout';
import Contact from './pages/Contact/Contact';
import './styles/global.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <LanguageProvider>
      <Routes>
        <Route path='/' element={<LandingPage />} />
        <Route path='/sobre' element={<MoreAbout />} />
        <Route path='/contatos' element={<Contact />} />
      </Routes>
    </LanguageProvider>
  </BrowserRouter>
);
